import React from "react";

function MonthFilter({
  months,
  selectedMonth,
  selectedMonthName,
  handleMonthChange,
}) {
  return (
    <div className="col-sm-3">
      <select
        id="month-select"
        className="form-select"
        onChange={handleMonthChange}
      >
        <option defaultValue disabled={selectedMonth || selectedMonthName}>
          Select Month
        </option>
        <option value="AllMonths">All Months</option>
        {months.map((month, index) => (
          <option key={index} value={JSON.stringify(month.createdAt)}>
            {month.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default MonthFilter;
